import { render, staticRenderFns } from "./LtkHeroImage.vue?vue&type=template&id=70a2e870&scoped=true"
import script from "./LtkHeroImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtkHeroImage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LtkHeroImage.vue?vue&type=style&index=0&id=70a2e870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a2e870",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CSkeletonLoader: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CSkeletonLoader/CSkeletonLoader.vue').default,CLtkImg: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CLtkImg/CLtkImg.vue').default,CIcon: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CIcon/CIcon.vue').default,CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default,CCard: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CCard/CCard.vue').default,TrackPostImpression: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Track/TrackPostImpression.vue').default})
